module.exports = __webpack_public_path__ + "static/img/icon-p2-3gs.7b647e9d.png";